module.exports = "<label class=\"switch\">\n  <input type=\"checkbox\" [checked]=\"value\" (change)=\"changed.next()\">\n  <span class=\"slider round\"></span>\n</label>\n\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/toggle-switch/toggle-switch.component.html
// module id = 1542
// module chunks = 2